<template lang="pug">
component(:is="icon")
</template>
<script lang="ts" setup>
import * as HeroIconsOutline from '@heroicons/vue/24/outline'
import * as HeroIconsSolid from '@heroicons/vue/20/solid'

const props = defineProps({
  iconName: {
    type: String,
    required: true,
  },
  iconStyle: {
    type: String,
    default: 'outline',
  },
})

const { ...outlineIcons } = HeroIconsOutline
const { ...solidIcons } = HeroIconsSolid

const icon = props.iconStyle === 'solid' ? solidIcons[props.iconName as keyof object] : outlineIcons[props.iconName as keyof object]
</script>
